import { create } from 'zustand';

/**
 * "Momenti soldi": la peak-end rule applicata ai pochi istanti che contano
 * davvero (firma ricevuta, deal chiuso, incasso). Incassare 88k NON deve dare
 * lo stesso feedback di salvare una nota.
 *
 * Uso:
 *   import { celebrate } from '../../stores/moment.store';
 *   celebrate({ title: 'Incassato', amount: 12800, subtitle: 'Fattura #2026-014' });
 */
export interface MomentPayload {
  title: string;
  /** Importo in € animato in count-up al centro. */
  amount?: number;
  subtitle?: string;
  /** Tono dell'accento. Default 'ok'. */
  tone?: 'ok' | 'product' | 'marketing';
}

interface MomentState {
  active: boolean;
  payload: MomentPayload | null;
  celebrate: (p: MomentPayload) => void;
  dismiss: () => void;
}

export const useMomentStore = create<MomentState>((set) => ({
  active: false,
  payload: null,
  celebrate: (payload) => set({ active: true, payload }),
  dismiss: () => set({ active: false, payload: null }),
}));

export function celebrate(p: MomentPayload) {
  useMomentStore.getState().celebrate(p);
}
